export default {
  beforeRouteEnter(to, from, next) {
    next(vm => vm.reloadCurrentTenant(to.params.tenant_id));
  },

  watch: {
    '$route.params.tenant_id': function onTenantIdChange(tenantId) {
      this.reloadCurrentTenant(tenantId);
    },
  },

  computed: {
    tenant() {
      return this.$store.getters['tenants/current'];
    },
  },

  methods: {
    reloadCurrentTenant(tenantId) {
      if (!this.force && (this.$store.getters['tenants/current'].id || !tenantId)) {
        return null;
      }

      // récupération du nouveau tenant
      return this.$store
        .dispatch('tenants/getCurrent', {
          id: tenantId,
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
